/*
 * Project: bellcloud
 * File: packages/theme/tokens/spacing.ts
 * Description: Spacing scale tokens based on Bellcloud Design System
 */

export type SpacingTokens = {
  1: number;
  2: number;
  3: number;
  4: number;
  5: number;
  6: number;
  7: number;
  8: number;
  10: number;
  12: number;
  14: number;
};

export const spacing: SpacingTokens = {
  1: 2,
  2: 4,
  3: 6,
  4: 8,
  5: 12,
  6: 16,
  7: 20,
  8: 28,
  10: 32,
  12: 36,
  14: 40,
};
